import Wrapper from 'xpi-black-ui/Base/Wrapper';
import styled from 'styled-components';

const WrapperTable = styled(Wrapper)`
  @media only screen and (min-width: 0px) {
    min-width: 87%;
  }

  @media only screen and (min-width: 2500px) {
    min-width: 100%;
  }
`;

export default WrapperTable;
